module.exports = __webpack_public_path__ + "static/Wladyslawowo-671401ad19cf7a5e967b181c88a891cc.svg";